<template>
  <div id="result-map" class="result-map" :class="layout">
    <div id="map" v-loading="loading"></div>
    <slider :total="total" :period="period" />
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet.markercluster'
import ResultSlider from './ResultSlider.vue'
// import { getMapDataFromAPIItem } from '../../services/data'
import {
  OPEN_CATALOG_DIALOG,
  GET_CATALOG
} from '@/store/dialog/actions'
import {
  GET_EXHIBITION_ADDRESS
} from '@/store/search/constants'

// const L = window.L
const getMarkerIcon = (color) => L.icon({
  iconUrl: `static/marker-${color}.svg`,
  iconSize: [42, 42], // size of the icon
  iconAnchor: [21, 42], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -42] // point from which the popup should open relative to the iconAnchor
})

export default {
  name: 'result-map',
  props: ['resultsMap', 'resultsMapDetail', 'layout', 'dates', 'period', 'loading'],
  components: {
    slider: ResultSlider
  },
  data () {
    return {
      map: null,
      mapMarkers: {},
      mapLayers: {},
      tileLayer: {
        url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png ',
        options: {
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          maxZoom: 18
        }
      },
      total: 0
    }
  },
  methods: {
    initMap () {
      this.map = L.map('map', {
        zoomControl: false
      })
      L.control.zoom({ position: 'topleft' }).addTo(this.map)
      L.tileLayer(this.tileLayer.url, this.tileLayer.options).addTo(this.map)
    },
    invalidateSize () {
      setTimeout(() => {
        this.map.invalidateSize(true)
      }, 200)
    },
    getCluster (clusterData) {
      let arrayOfLatLngs = []
      const cluster = L.markerClusterGroup({
        spiderfyOnMaxZoom: false,
        zoomToBoundsOnClick: false,
        iconCreateFunction: (cluster) => {
          // get the number of items in the cluster
          var count = cluster.getChildCount()

          // figure out how many digits long the number is
          var digits = (count + '').length

          return new L.DivIcon({
            html: count,
            className: clusterData.color + ' cluster digits-' + digits,
            iconSize: null
          })
        }
      })
      // build the markers
      clusterData.data.forEach((currentData, index) => {
        if (currentData) {
          if (!!currentData.x && !!currentData.y) {
            arrayOfLatLngs.push([currentData.y, currentData.x])
            const marker = L.marker(
              [currentData.y, currentData.x],
              {icon: getMarkerIcon(clusterData.color)}
            ).bindPopup(currentData.popup)
            cluster.addLayer(marker)
            this.mapMarkers[currentData.id_exhibition] = marker
          }
        }
      })

      cluster.on('clusterclick', function (m) {
        let popupContent = ''
        let marker = null
        let childMarkers = m.layer.getAllChildMarkers()
        let markersAdded = []
        childMarkers.sort((a, b) => {
          let wrapperA = document.createElement('div')
          wrapperA.innerHTML = a._popup._content
          let indexA = wrapperA.firstChild.dataset.index

          let wrapperB = document.createElement('div')
          wrapperB.innerHTML = b._popup._content
          let indexB = wrapperB.firstChild.dataset.index
          return indexB - indexA
        })
        childMarkers.map(layer => {
          marker = cluster.getVisibleParent(layer)
          const layerContent = layer._popup._content
          const indexBeginIdExhibition = layerContent.indexOf('data-id') + 9
          const indexEndIdExhibition = layerContent.substring(indexBeginIdExhibition).indexOf('"')
          const idExhibition = layerContent.substr(indexBeginIdExhibition, indexEndIdExhibition)
          // add the popup content only if we don't have already added the same content
          if (markersAdded.indexOf(idExhibition) < 0) {
            popupContent += `<li>${layer._popup._content}</li>`
            markersAdded.push(idExhibition)
          }
        })
        marker.bindPopup(`<ul>${popupContent}</ul>`).openPopup()
      })
      return cluster
    },
    setMarkers () {
      if (this.resultsMap.length < 1) {
        return false
      }

      // remove previous layers
      Object.keys(this.mapLayers).map(i => {
        // this.controlLayers.removeLayer(this.mapLayers[i])
        this.map.removeLayer(this.mapLayers[i])
      })
      this.mapLayers = {}
      let arrayOfLatLngs = []
      this.i = 0
      this.resultsMap.forEach(currentLayer => {
        this.mapLayers[currentLayer.layer] = this.getCluster({
          data: currentLayer.data,
          color: currentLayer.color
        })
        if (this.i === 0) {
          this.map.addLayer(this.mapLayers[currentLayer.layer])
          arrayOfLatLngs = arrayOfLatLngs.concat(currentLayer.arrayOfLatLngs)
        }
        this.i += 1
      })

      this.total = this.resultsMap[0].arrayOfLatLngs.length
      var bounds = new L.LatLngBounds(arrayOfLatLngs)
      this.map.fitBounds(bounds)

      this.setPopupEvents()
      this.addControlLayers()
    },
    openCatalogDialog (obj, id) {
      this.$store.dispatch('dialog/' + OPEN_CATALOG_DIALOG)
      this.$store.dispatch('dialog/' + GET_CATALOG, {
        id
      })
    },
    setPopupEvents () {
      this.map.on('popupopen', (e) => {
        let elements = document.querySelectorAll('.exhibition_item')
        elements.forEach(el => {
          el.addEventListener('click', () => {
            const index = el.dataset.index
            const exhibitionId = el.dataset.id
            this.openCatalogDialog(this.resultsMap[index], exhibitionId)
          })
        })
      })

      this.map.on('popupclose', (e) => {
        let elements = document.querySelectorAll('.exhibition_item')
        elements.forEach(el => {
          el.removeEventListener('click', () => {
            const index = el.dataset.index
            const exhibitionId = el.dataset.id
            this.openCatalogDialog(this.resultsMap[index], exhibitionId)
          })
        })
      })

      const focusedMarker = this.mapMarkers[this.resultsMapDetail]
      if (focusedMarker) {
        let latLngs = [ focusedMarker.getLatLng() ]
        let markerBounds = L.latLngBounds(latLngs)
        this.map.fitBounds(markerBounds, {maxZoom: 14})
      }
    },
    /**
     * This function has to center map on the selected POI
     * TODO: adapt the code to be able to get all the layers requested upon the search
     * exhibitor, exhibition, exhibited_work
     */
    focusOnPOI () {
      const focusedMarker = this.mapMarkers[this.resultsMapDetail]
      if (focusedMarker) {
        let latLngs = [ focusedMarker.getLatLng() ]
        let markerBounds = L.latLngBounds(latLngs)
        this.map.fitBounds(markerBounds, {maxZoom: 14})
      } else {
        this.$store.dispatch('search/' + GET_EXHIBITION_ADDRESS, {
          id: this.resultsMapDetail
        })
      }
    },
    addControlLayers () {
      if (this.controlLayers) {
        this.map.removeControl(this.controlLayers)
      }

      const layers = {}
      this.resultsMap.forEach(currentResult => {
        layers["<img width='16px' src='static/marker-" + currentResult.color + ".svg'/>" + this.$t(`map.layers.${currentResult.layer}`)] = this.mapLayers[currentResult.layer]
      })
      this.controlLayers = L.control.layers({}, layers).addTo(this.map)
    }
  },
  watch: {
    'layout': 'invalidateSize',
    'resultsMap': {
      handler: function () {
        this.setMarkers()
      },
      deep: true
    },
    'resultsMapDetail': 'focusOnPOI',
    '$i18n.locale': 'addControlLayers'
  },
  mounted () {
    this.initMap()
  }
}
</script>
<style>
.result-map #map {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 80px;
}
.result-map.hide {
  display: none;
  position: fixed;
  top: 127px;
  bottom: 0;
  left: 100%;
  right: 0;
}
.result-map.column-100 {
  left: 0;
}
.result-map .leaflet-container a.leaflet-popup-close-button {
  padding: 2px 2px 2px 2px;
  line-height: 15px;
  width: 16px;
  height: 16px;
  transition: all .3s;
  background: white;
}
.leaflet-popup-content-wrapper {
  padding: 0;
  border-radius: 1px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .12), 0px 0px 6px 0px rgba(0, 0, 0, .04);
}
.leaflet-popup-content {
  max-height: 200px;
  overflow: auto;
  margin: 0;
  padding: .5em 1em;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}
.leaflet-popup-content-wrapper .date,
.leaflet-popup-content-wrapper .name {
  color: #35C1D6;
  text-transform: capitalize;
}
.leaflet-popup-content-wrapper .city,
.leaflet-popup-content-wrapper .space {
  font-weight: bold;
  text-transform: capitalize;
}
.leaflet-popup-content ul {
  margin: 0;
  padding: 0;
}
.leaflet-popup-content li {
  list-style-type: none;
  border-bottom: 1px solid rgb(223, 234, 236);
}
.leaflet-popup-content li:last-child {
  border-bottom-color: transparent;
}
.exhibited-work-title {
  font-style: italic;
}
.exhibition_item {
  padding: .5em 0;
}
.exhibition_item:hover,
.exhibition_item:active {
  cursor: pointer;
  background: rgb(238, 244, 246);
}

.cluster.blue {
  background: #35C1D6;
  border: 1px solid #35C1D6;
}
.cluster.red {
  background: #ff1a00;
  border: 1px solid #ff1a00;
}
.cluster.yellow {
  background: #ff0;
  border: 1px solid #ff0;
  color: #999
}
.cluster.green {
  background: #b6e026;
  border: 1px solid #b6e026;
}
.cluster.purple {
  background: #cb60b3;
  border: 1px solid #cb60b3;
}
.cluster.orange {
  background: #febf01;
  border: 1px solid #febf01;
}

.cluster {
  border-radius: 50%;
  text-align: center;
  color: white;
  font-weight: 700;
  font-family: monospace;
}

.cluster:before {
    content: ' ';
    position: absolute;
    border-radius: 50%;
    z-index: -1;
    top: 1px;
    left: 1px;
    right: 1px;
    bottom: 1px;
    border: 1px solid white;
}

.digits-1 {
  font-size: 14px;
  height: 28px;
  width: 28px;
  line-height: 28px;
  margin-top: -14px;
  margin-left: -14px;
}

.digits-2 {
  font-size: 16px;
  height: 34px;
  width: 34px;
  line-height: 35px;
  margin-top: -17px;
  margin-left: -17px;
}

.digits-2:before {
  border-width: 2px;
}

.digits-3 {
  font-size: 18px;
  height: 48px;
  width: 47px;
  line-height: 47px;
  border-width: 3px;
  margin-top: -24px;
  margin-left: -24px;
}

.digits-3:before {
  border-width: 3px;
}

.digits-4 {
  font-size: 18px;
  height: 58px;
  width: 58px;
  line-height: 57px;
  border-width: 4px;
  margin-top: -29px;
  margin-left: -29px;
}

.digits-4:before {
  border-width: 4px;
}

@media (min-width: 992px) {
  .result-map {
    position: fixed;
    top: 127px;
    bottom: 0;
    left: 65%;
    right: 0;
  }
}

@media (min-width: 1400px) {
  .result-map {
    left: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Result/ResultMap.vue